<template>
  <base-form-detail
    :controller="controller"
    :dialog="dialog"
    :readonly="readonly"
    @close="$emit('close')"
    @save="$emit('save')"
  >
    <entity-card-care-partners-detail-general-information
      :codes="contentMixin.codes"
      :readonly="readonly"
      :source="source"
    />
    <entity-card-care-partners-detail-contact-details
      :codes="contentMixin.codes"
      :posts="lists.posts"
      :readonly="readonly"
      :source="source"
    />
    <entity-card-care-partners-detail-extra-information
      :readonly="readonly"
      :source="source"
    />
  </base-form-detail>
</template>

<script>
import BaseFormDetail from '@/components/shared/base/base-form-detail'
import EntityCardCarePartnersDetailContactDetails from '@/components/shared/entitycards/entity-card-care-partners-detail-contact-details'
import EntityCardCarePartnersDetailExtraInformation from '@/components/shared/entitycards/entity-card-care-partners-detail-extra-information'
import EntityCardCarePartnersDetailGeneralInformation from '@/components/shared/entitycards/entity-card-care-partners-detail-general-information'
import BaseFormDetailMixin from '@/mixins/base-form-detail-mixin'

export default {
  name: 'CarePartnersDetail',
  components: {
    BaseFormDetail,
    EntityCardCarePartnersDetailContactDetails,
    EntityCardCarePartnersDetailExtraInformation,
    EntityCardCarePartnersDetailGeneralInformation
  },
  mixins: [
    BaseFormDetailMixin
  ],
  data () {
    return {
      controller: 'CarePartner',
      lists: {
        posts: []
      }
    }
  },
  mounted () {
    this.Initialize()
  },
  methods: {
    async Initialize () {
      await this.BaseFormDetailMixin_Initialize(this.controller)
      await this.ContentMixin_Service_BC_InitializeCodes()
      this.lists.posts = await this.ContentMixin_Service_BC_PickSource('Post')
    }
  }
}
</script>
